import { w as withConfigTransport } from "../../services/config-transport/withConfigTransport.js";
import { _ as _sfc_main } from "./VaStepper.vue_vue_type_script_setup_true_lang.js";
const VaStepper = withConfigTransport(_sfc_main);
const defineVaStepperSteps = (steps) => steps;
export {
  VaStepper as V,
  defineVaStepperSteps as d
};
//# sourceMappingURL=index.js.map
